import { Suspense, type ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import i18n from '@shared/i18n/config';

interface I18nProviderProps {
  children: ReactNode;
}

function I18nFallback() {
  return (
    <div
      aria-busy="true"
      className="flex min-h-screen items-center justify-center bg-bg text-text-dim"
    />
  );
}

export function I18nProvider({ children }: I18nProviderProps) {
  return (
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<I18nFallback />}>{children}</Suspense>
    </I18nextProvider>
  );
}
